export default __webpack_public_path__ + "static/media/Stage1.ef4b135b.svg";